import React, { useCallback, useState } from 'react'
import { Grid } from '@material-ui/core'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'
import ScanViewTileItem from 'components/common/ScanView/ScanViewTileItem'
import { getObjectUrl } from 'utils/mediaUtils'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import ImagesViewer from 'components/common/ImagesViewer'

const useStyles = makeStyles(theme => ({
  OHImage: {
    height: 72,
    width: 120,
    borderRadius: 10,
    cursor: 'pointer',
    objectFit: 'cover',
    aspectRatio: 1.66,
    userSelect: 'none'
  },
  unselectedImage: {
    opacity: '1 !important'
  }
}))

const AISuggestedImages = ({ scanId, oralHygieneRecommendationImages, selectedImagesIndex, handleImageSelected }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const [isImageViewerOpen, setIsImageViewerOpen] = useState(false)

  const handleCurrentImageChanged = useCallback(() => {
    setIsImageViewerOpen(true)
  }, [])

  return (
    oralHygieneRecommendationImages.length > 0 && (
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <DazzedParagraph12 strong>
            {t('pages.patients.selectedPatient.chat.gi.AIMessagePatient.suggestedAttachments')}
          </DazzedParagraph12>
        </Grid>
        <Grid item>
          <Grid container alignItems="center" spacing={1}>
            {oralHygieneRecommendationImages.map((image, index) => (
              <Grid item key={image.key}>
                <ScanViewTileItem
                  withCheckbox
                  mediaType="img"
                  src={getObjectUrl(image)}
                  onClick={() => handleCurrentImageChanged(index)}
                  optionMediaClassName={classes.OHImage}
                  unselectedOptionClassName={classes.unselectedImage}
                  isChecked={selectedImagesIndex.includes(index)}
                  setIsChecked={() => handleImageSelected(index)}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <ImagesViewer
          isVisible={isImageViewerOpen}
          onClose={() => setIsImageViewerOpen(false)}
          imageS3Objects={oralHygieneRecommendationImages}
        />
      </Grid>
    )
  )
}

export default AISuggestedImages
